// Classes
import DateTime from "./DateTime";

// NPM
import moment from "moment";

export default class Calendar {
	public static generateDateRangeFrom(date: string, size: number): string[] {
		const dateRange: string[] = [];

		const current = moment(date);

		for (let i = 0; i < size; i++) {
			dateRange.push(current.format(DateTime.DEFAULT_DATE_FORMAT));
			current.add(1, "day");
		}

		return dateRange;
	}

	public static datesAreSame(first: string, second: string): boolean {
		return (
			moment(first).format(DateTime.DEFAULT_DATE_FORMAT) ===
			moment(second).format(DateTime.DEFAULT_DATE_FORMAT)
		);
	}
}
